import { useIntl } from "react-intl";
import { Row, Col, Button, Form } from "react-bootstrap";
import { ChangeEvent, useEffect, useState } from "react";
import Pacman from "src/app/components/layout/Pacman";
import { CkEditorCustom } from "src/app/components";
import { checkLink, countWord } from "src/app/utils/stringHelper";
import { toAbsoluteUrl, KTSVG } from "src/_metronic/helpers";
import SVG from "react-inlinesvg";
import { copyLinkToClipboard } from "src/app/utils/stringHelper";

export const AIGuideFormStepsList = (
    prompt: {
        intentSearchSuggest: string | null;
        metaDescriptionSuggest: string | null;
        metaTitleSuggest: string | null;
        planSuggest: string | null;
        textSuggest: string | null;
        titleSuggest: string | null;
    },
    loading: boolean,
    extraInformation: {
        value: string | null;
        setInfo: (value: string) => void;
    },
    handleFields: {
        intentSearch: {
            input: string | null;
            setIntentSearch: (value: string) => void;
            requestIntentSearch: () => void;
            requestLoading: boolean;
        };
        title: {
            input: string | null;
            setTitle: (value: string) => void;
            requestTitle: () => void;
            requestLoading: boolean;
        };
        plan: {
            input: string | null;
            setPlan: (value: string) => void;
            requestPlan: () => void;
            requestLoading: boolean;
        };
        meta: {
            setMetaTitle: (value: string) => void;
            setMetaDescription: (value: string) => void;
            input: {
                mt: string | null;
                md: string | null;
            };
            requestLoading: boolean;
            requestMeta: () => void;
        };
        text: {
            input: string | null;
            setText: (value: string) => void;
            wordCount: number;
            links: { url?: string; anchor?: string }[] | null;
            requestText: () => void;
            youtubeLink: string | null;
            requestPeopleAlsoAsk: () => void;
            peopleAlsoAsk: string;
            disableGoToYoutube: boolean;
            requestLoading: boolean;
        };
        image: {
            input: string | null;
            setImage: (value: string) => void;
            requestImage: () => void;
            requestLoading: boolean;
        };
    },
    toClipboard: (elementId: string) => void
) => {
    const { formatMessage } = useIntl();

    const handleText = (text: string) => {
        return text
            .replaceAll(/(?<!\\)"/g, "")
            .replaceAll(/(\\n)/g, "<br/>")
            .replaceAll(/\\"/g, `"`);
    };

    const [reduceLeftSide, setReduceLeftSide] = useState(false);
    const handleLeftSide = () => {
        setReduceLeftSide(!reduceLeftSide);
    };

    useEffect(() => {
        const toBeCopyGuide = document.getElementById("toBeCopyGuide");
        const toBeCopyTitle = document.getElementById("toBeCopyTitle");
        const toBeCopyPlan = document.getElementById("toBeCopyPlan");
        const toBeCopyMeta = document.getElementById("toBeCopyMeta");
        const toBeCopyText = document.getElementById("toBeCopyText");

        if (toBeCopyGuide && prompt.intentSearchSuggest) {
            const innerHtml = `${handleText(prompt.intentSearchSuggest)}
              `;

            toBeCopyGuide.innerHTML = innerHtml;
        }
        if (toBeCopyTitle && prompt.titleSuggest) {
            const innerHtml = `${handleText(prompt.titleSuggest)}
              `;

            toBeCopyTitle.innerHTML = innerHtml;
        }
        if (toBeCopyPlan && prompt.planSuggest) {
            const innerHtml = `${handleText(prompt.planSuggest)}
               ${
                   extraInformation.value
                       ? `\n\n<h2>Information important:</h2>\n\n ${extraInformation.value}`
                       : ""
               }`;

            toBeCopyPlan.innerHTML = innerHtml;
        }
        if (toBeCopyMeta && prompt.metaTitleSuggest && prompt.metaDescriptionSuggest) {
            const innerHtml = `${handleText(prompt.metaTitleSuggest)}
               ${prompt.metaDescriptionSuggest}`;

            toBeCopyMeta.innerHTML = innerHtml;
        }
        if (toBeCopyText && prompt.textSuggest) {
            const innerHtml = `${handleText(prompt.textSuggest)}
              `;

            toBeCopyText.innerHTML = innerHtml;
        }
    }, [prompt]);
    //we need this code to remove the "autoFocus" from the modal, if we don't have this code we can't write in the Link popUp from  CKEditor
    useEffect(() => {
        const doc = document.querySelector(".modal");
        doc?.removeAttribute("tabindex");
    }, []);

    const linksStatus: { url?: string; anchor?: string; isValid: boolean }[] = [];

    if (handleFields.text.input && handleFields.text.links && handleFields.text.links.length > 0) {
        const linksChecked = checkLink(handleFields.text.input, handleFields.text.links);

        handleFields.text.links.forEach((link) => {
            if (link.anchor) {
                const anchor = link.anchor.toLowerCase();

                const isValid =
                    linksChecked[anchor] &&
                    linksChecked[anchor].badLink === 0 &&
                    linksChecked[anchor].urls.length > 0 &&
                    linksChecked[anchor].urls.some((url) => url.number > 0);

                linksStatus.push({
                    ...link,
                    isValid,
                });
            }
        });
    }

    const peopleAlsoAskDisable = () => {
        if (!prompt.intentSearchSuggest) return false;
        const initIndex = prompt.intentSearchSuggest.indexOf("people_also_ask");

        return initIndex < 0;
    };

    const steps = [
        {
            // Step 1 - Intent Search
            title: `${formatMessage({ id: "common.stepper.getIntentSearch" })}`,
            element: (
                <Row className="d-flex">
                    <Col sm={reduceLeftSide ? 1 : 6} className="d-flex flex-column">
                        <Row>
                            <Col sm={12}>
                                <p className="text-center">
                                    <b>{formatMessage({ id: "common.text.getIntentSearch" })}</b>
                                </p>
                                <div>
                                    <Button onClick={() => handleLeftSide()}>
                                        <SVG
                                            className={`svg-icon-1 ${
                                                reduceLeftSide ? "rotate-180deg" : ""
                                            }`}
                                            src={toAbsoluteUrl(
                                                "/media/icons/duotune/arrows/arr079.svg"
                                            )}
                                        />
                                    </Button>
                                </div>
                                <div
                                    style={{
                                        maxHeight: "70vh",
                                        overflow: "scroll",
                                        overflowX: "hidden",
                                        borderRadius: "12px",
                                        padding: "16px",
                                    }}
                                    id="toBeCopyGuide"
                                >
                                    {loading && <Pacman />}
                                </div>
                            </Col>
                        </Row>
                        <Row className={`mt-5 ${reduceLeftSide ? "d-none" : ""}`}>
                            <Col>
                                <Button onClick={() => toClipboard("toBeCopyGuide")}>
                                    {formatMessage({ id: "common.action.copyPrompt" })}
                                </Button>
                            </Col>
                            <Col className="text-end">
                                <Button
                                    disabled={handleFields.intentSearch.requestLoading}
                                    onClick={() => handleFields.intentSearch.requestIntentSearch()}
                                >
                                    {formatMessage({ id: "common.action.jarvisAiManualSerp" })}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col
                        sm={reduceLeftSide ? 11 : 6}
                        style={{
                            maxHeight: "80vh",
                            overflow: "scroll",
                            overflowX: "hidden",
                            borderRadius: "12px",
                            padding: "16px",
                        }}
                    >
                        <Row className="d-flex h-100">
                            <div className="h-100 w-100">
                                <CkEditorCustom
                                    data={handleFields.intentSearch.input || ""}
                                    onChange={(event: any, editor) => {
                                        const data = editor.getData();
                                        handleFields.intentSearch.setIntentSearch(data);
                                    }}
                                />
                            </div>
                        </Row>
                    </Col>
                </Row>
            ),
        },
        {
            // Step 2 - Title
            title: `${formatMessage({ id: "common.stepper.getTitle" })}`,
            element: (
                <Row>
                    <Col sm={reduceLeftSide ? 1 : 6} className="d-flex flex-column">
                        <Row>
                            <Row>
                                <p className="text-center">
                                    <b>{formatMessage({ id: "common.text.getTitle" })}</b>
                                </p>
                                <div>
                                    <Button onClick={() => handleLeftSide()}>
                                        <SVG
                                            className={`svg-icon-1 ${
                                                reduceLeftSide ? "rotate-180deg" : ""
                                            }`}
                                            src={toAbsoluteUrl(
                                                "/media/icons/duotune/arrows/arr079.svg"
                                            )}
                                        />
                                    </Button>
                                </div>
                                <div
                                    style={{
                                        maxHeight: "59vh",
                                        overflow: "scroll",
                                        overflowX: "hidden",
                                        borderRadius: "12px",
                                        padding: "16px",
                                    }}
                                    id="toBeCopyTitle"
                                >
                                    {!prompt.intentSearchSuggest
                                        ? loading && <Pacman />
                                        : prompt.intentSearchSuggest}
                                </div>
                            </Row>
                            <Row className={`mt-5 ${reduceLeftSide ? "d-none" : ""}`}>
                                <label>extra Information</label>
                                <textarea
                                    className="form-control mb-2"
                                    name="extraPlanInfo"
                                    value={extraInformation.value || undefined}
                                    onChange={(ev) =>
                                        extraInformation.setInfo(ev.currentTarget.value)
                                    }
                                />
                                <Col>
                                    <Button onClick={() => toClipboard("toBeCopyTitle")}>
                                        {formatMessage({ id: "common.action.copyPrompt" })}
                                    </Button>
                                </Col>
                                <Col className="text-end">
                                    <Button
                                        disabled={handleFields.title.requestLoading}
                                        onClick={() => handleFields.title.requestTitle()}
                                    >
                                        {formatMessage({ id: "common.action.jarvisAiManualTitle" })}
                                    </Button>
                                </Col>
                            </Row>
                        </Row>
                    </Col>
                    <Col sm={reduceLeftSide ? 11 : 6}>
                        <Form.Label>{formatMessage({ id: "common.field.title" })}</Form.Label>
                        <Form.Control
                            name="title"
                            value={handleFields.title.input || ""}
                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                handleFields.title.setTitle(event.target.value);
                            }}
                            required
                        />
                    </Col>
                </Row>
            ),
        },
        {
            // Step 3 - Plan
            title: `${formatMessage({ id: "common.stepper.getPlan" })}`,
            element: (
                <Row>
                    <Col sm={reduceLeftSide ? 1 : 6} className="d-flex flex-column">
                        <Row>
                            <Row>
                                <p className="text-center">
                                    <b>{formatMessage({ id: "common.text.getPlan" })}</b>
                                </p>
                                <div>
                                    <Button onClick={() => handleLeftSide()}>
                                        <SVG
                                            className={`svg-icon-1 ${
                                                reduceLeftSide ? "rotate-180deg" : ""
                                            }`}
                                            src={toAbsoluteUrl(
                                                "/media/icons/duotune/arrows/arr079.svg"
                                            )}
                                        />
                                    </Button>
                                </div>
                                <div
                                    style={{
                                        maxHeight: "59vh",
                                        overflow: "scroll",
                                        overflowX: "hidden",
                                        borderRadius: "12px",
                                        padding: "16px",
                                    }}
                                    id="toBeCopyPlan"
                                >
                                    {loading && <Pacman />}
                                </div>
                            </Row>

                            <Row className={`mt-5 ${reduceLeftSide ? "d-none" : ""}`}>
                                <label>extra Information</label>
                                <textarea
                                    className="form-control mb-2"
                                    name="extraPlanInfo"
                                    value={extraInformation.value || undefined}
                                    onChange={(ev) =>
                                        extraInformation.setInfo(ev.currentTarget.value)
                                    }
                                />
                                <Col>
                                    <Button onClick={() => toClipboard("toBeCopyPlan")}>
                                        {formatMessage({ id: "common.action.copyPrompt" })}
                                    </Button>
                                </Col>
                                <Col className="text-end">
                                    <Button
                                        disabled={handleFields.plan.requestLoading}
                                        onClick={() => handleFields.plan.requestPlan()}
                                    >
                                        {formatMessage({ id: "common.action.jarvisAiManualPlan" })}
                                    </Button>
                                </Col>
                            </Row>
                        </Row>
                    </Col>
                    <Col
                        sm={reduceLeftSide ? 11 : 6}
                        style={{
                            maxHeight: "70vh",
                            overflow: "scroll",
                            overflowX: "hidden",
                            borderRadius: "12px",
                            padding: "16px",
                        }}
                    >
                        <Row>
                            <div className="h-100 w-100">
                                <CkEditorCustom
                                    data={handleFields.plan.input || ""}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        handleFields.plan.setPlan(data);
                                    }}
                                />
                            </div>
                        </Row>
                    </Col>
                </Row>
            ),
        },
        {
            // Step 4 - Meta
            title: `${formatMessage({ id: "common.stepper.getMeta" })}`,
            element: (
                <Row>
                    <Col sm={reduceLeftSide ? 1 : 6} className="d-flex flex-column">
                        <Row>
                            <Row>
                                <p className="text-center">
                                    <b>{formatMessage({ id: "common.text.getMeta" })}</b>
                                </p>
                                <div>
                                    <Button onClick={() => handleLeftSide()}>
                                        <SVG
                                            className={`svg-icon-1 ${
                                                reduceLeftSide ? "rotate-180deg" : ""
                                            }`}
                                            src={toAbsoluteUrl(
                                                "/media/icons/duotune/arrows/arr079.svg"
                                            )}
                                        />
                                    </Button>
                                </div>
                                <div
                                    style={{
                                        maxHeight: "70vh",
                                        overflow: "scroll",
                                        overflowX: "hidden",
                                        borderRadius: "12px",
                                        padding: "16px",
                                    }}
                                    id="toBeCopyMeta"
                                >
                                    {loading && <Pacman />}
                                </div>
                            </Row>
                            <Row className={`mt-5 ${reduceLeftSide ? "d-none" : ""}`}>
                                <Col>
                                    <Button onClick={() => toClipboard("toBeCopyMeta")}>
                                        {formatMessage({ id: "common.action.copyPrompt" })}
                                    </Button>
                                </Col>
                                <Col className="text-end">
                                    <Button
                                        disabled={handleFields.meta.requestLoading}
                                        onClick={() => handleFields.meta.requestMeta()}
                                    >
                                        {formatMessage({ id: "common.action.jarvisAiManualMeta" })}
                                    </Button>
                                </Col>
                            </Row>
                        </Row>
                    </Col>
                    <Col sm={reduceLeftSide ? 11 : 6}>
                        <Form.Label>{formatMessage({ id: "common.field.metaTitle" })}</Form.Label>
                        <Form.Control
                            name="metaTitle"
                            value={handleFields.meta.input.mt || ""}
                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                handleFields.meta.setMetaTitle(event.target.value);
                            }}
                            required
                        />
                        <Form.Label>
                            {formatMessage({ id: "common.field.metaDescription" })}
                        </Form.Label>
                        <Form.Control
                            name="metaDescription"
                            value={handleFields.meta.input.md || ""}
                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                handleFields.meta.setMetaDescription(event.target.value);
                            }}
                        />
                    </Col>
                </Row>
            ),
        },
        {
            // Step 5 - Text
            title: `${formatMessage({ id: "common.stepper.getText" })}`,
            element: (
                <Row>
                    <Col sm={reduceLeftSide ? 1 : 6} className="d-flex flex-column">
                        <Row>
                            <Row>
                                <p className="text-center">
                                    <b>{formatMessage({ id: "common.text.getText" })}</b>
                                </p>
                                <div>
                                    <Button onClick={() => handleLeftSide()}>
                                        <SVG
                                            className={`svg-icon-1 ${
                                                reduceLeftSide ? "rotate-180deg" : ""
                                            }`}
                                            src={toAbsoluteUrl(
                                                "/media/icons/duotune/arrows/arr079.svg"
                                            )}
                                        />
                                    </Button>
                                </div>
                                <div
                                    style={{
                                        maxHeight: "59vh",
                                        overflow: "scroll",
                                        overflowX: "hidden",
                                        borderRadius: "12px",
                                        padding: "16px",
                                    }}
                                    id="toBeCopyText"
                                >
                                    {loading && <Pacman />}
                                </div>
                            </Row>
                            <Row className={`mt-5 ${reduceLeftSide ? "d-none" : ""}`}>
                                <label>extra Information</label>
                                <textarea
                                    className="form-control mb-2"
                                    name="extraPlanInfo"
                                    value={extraInformation.value || undefined}
                                    onChange={(ev) =>
                                        extraInformation.setInfo(ev.currentTarget.value)
                                    }
                                />
                                <Col sm={5}>
                                    <Button onClick={() => toClipboard("toBeCopyText")}>
                                        {formatMessage({ id: "common.action.copyPrompt" })}
                                    </Button>
                                </Col>
                                <Col>
                                    <Row>
                                        <Col>
                                            {!!handleFields.text.youtubeLink && (
                                                <a
                                                    href={handleFields.text.youtubeLink}
                                                    target="_blank"
                                                >
                                                    <KTSVG
                                                        path="/media/icons/duotune/social/soc007.svg"
                                                        className="youtube-icon"
                                                    />
                                                    {formatMessage({
                                                        id: "common.action.goToYoutube",
                                                    })}
                                                </a>
                                            )}
                                        </Col>
                                        <Col>
                                            <a
                                                className={
                                                    peopleAlsoAskDisable()
                                                        ? "anchor-disable"
                                                        : "anchor-enable"
                                                }
                                                onClick={() =>
                                                    handleFields.text.requestPeopleAlsoAsk()
                                                }
                                            >
                                                <KTSVG
                                                    path="/media/icons/personal/google.svg"
                                                    className="google-icon"
                                                />
                                                {formatMessage({
                                                    id: "common.action.peopleAlsoAsk",
                                                })}
                                            </a>
                                        </Col>
                                        <Col>
                                            <Button
                                                disabled={handleFields.text.requestLoading}
                                                onClick={() => handleFields.text.requestText()}
                                            >
                                                {formatMessage({
                                                    id: "common.action.jarvisAiManualText",
                                                })}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Row>
                    </Col>
                    <Col
                        sm={reduceLeftSide ? 11 : 6}
                        style={{
                            maxHeight: "80vh",
                            overflow: "scroll",
                            overflowX: "hidden",
                            borderRadius: "12px",
                            padding: "16px",
                        }}
                    >
                        <Row className="d-flex h-100 w-100">
                            <div>
                                <span className="form-label">
                                    {formatMessage({ id: "content.grid.col.words" })} :{" "}
                                </span>{" "}
                                {countWord(handleFields.text.input || "")}/
                                {handleFields.text.wordCount}
                            </div>
                            {handleFields.text.links && handleFields.text.links.length > 0 && (
                                <>
                                    {linksStatus.map((linkStatus, index) => (
                                        <div
                                            key={index}
                                            className="border-1 link-copyPaste"
                                            onClick={() => {
                                                if (linkStatus.anchor && linkStatus.url) {
                                                    copyLinkToClipboard(
                                                        linkStatus.anchor!,
                                                        linkStatus.url!
                                                    );
                                                }
                                            }}
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "0.5fr 0.40fr 10fr",
                                                marginBottom: "5px",
                                            }}
                                        >
                                            <div style={{ width: "fit-content" }}>
                                                {linkStatus.isValid ? (
                                                    <SVG
                                                        src={toAbsoluteUrl(
                                                            "/media/icons/duotune/general/gen037.svg"
                                                        )}
                                                        className="svg-icon-valid"
                                                    />
                                                ) : (
                                                    <SVG
                                                        src={toAbsoluteUrl(
                                                            "/media/icons/duotune/general/gen034.svg"
                                                        )}
                                                        className="svg-icon-danger"
                                                    />
                                                )}
                                            </div>
                                            <span className="form-label">Link: </span>{" "}
                                            {linkStatus.url} ({linkStatus.anchor})
                                        </div>
                                    ))}
                                </>
                            )}
                            <Row className="d-flex h-100 w-100">
                                <div className="h-100 w-100">
                                    <CkEditorCustom
                                        data={handleFields.text.input || ""}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            handleFields.text.setText(data);
                                        }}
                                    />
                                </div>
                            </Row>
                        </Row>
                    </Col>
                </Row>
            ),
        },
    ];
    return steps;
};
